import React from 'react';
import { ArticleMiniPreview } from '../../../article-mini-preview/article-mini-preview';
import styles from './table-cell-article.module.scss';

type Props = {
  hexCode: string | undefined;
  series: string;
  seriesNumber: string;
  pimArticleId: string;
  hasRendering: boolean;
};

// TODO: @Simon make nice type handling for the props
export const TableCellArticle: React.FC<Props> = (props) => {
  return (
    <div className={styles.root}>
      <ArticleMiniPreview {...props} />
    </div>
  );
};
